import CONSTANT from "@api/constant";
export default [{
  path: '/market',
  name: 'market',
  meta: {
    platformType: CONSTANT.SHOP
  },
  component: function component() {
    return import('@/layouts/market-layout');
  },
  redirect: {
    name: 'm-home'
  },
  children: [{
    path: '/',
    name: 'm-home',
    component: function component() {
      return import('@/pagesMarket/shopping/home/index.vue');
    }
  }, {
    path: 'goInquiry',
    name: 'm-goInquiry',
    component: function component() {
      return import('@/pagesMarket/shopping/home/goInquiry/goInquiry.vue');
    }
  }, {
    path: 'orderConfirm',
    name: 'm-orderConfirm',
    component: function component() {
      return import('@/pagesMarket/shopping/orderConfirm/orderConfirm.vue');
    }
  }, {
    path: 'homeEnquiryDetail',
    name: 'm-homeEnquiryDetail',
    component: function component() {
      return import('@/pagesMarket/shopping/home/goInquiry/enquiryDetail/enquiryDetail.vue');
    }
  }]
}];